"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

exports.__esModule = true;
exports["default"] = void 0;

var _start = _interopRequireDefault(require("./start"));

var _end = _interopRequireDefault(require("./end"));
/**
 * Get attributed string length
 *
 * @param  {Object}  glyph string
 * @return {number} end
 */


var length = function length(attributedString) {
  return (0, _end["default"])(attributedString) - (0, _start["default"])(attributedString);
};

var _default = length;
exports["default"] = _default;